import { TextField, Typography, Divider, Box, InputAdornment } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import theme from './Theme';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface ContactFieldsProps {
  formData: PlaceFormData;
  errors: Record<string, string>;
  onChange: (name: string, value: any) => void;
}

const focusStyles = {
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': { borderColor: 'primary.main' },
    '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
  },
};

export const ContactFields = ({ formData, errors, onChange }: ContactFieldsProps) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Contact Information
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <TextField
        label="Phone"
        name="phone"
        value={formData.contacts.phone}
        onChange={(e) => onChange('contacts.phone', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors['contacts.phone']}
        helperText={errors['contacts.phone']}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PhoneIcon sx={{ color: theme.palette.accent.main }} />
            </InputAdornment>
          ),
        }}
        sx={focusStyles}
      />
      <TextField
        label="Website"
        name="website"
        value={formData.contacts.website}
        onChange={(e) => onChange('contacts.website', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors['contacts.website']}
        helperText={errors['contacts.website']}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LanguageIcon sx={{ color: theme.palette.accent.main }} />
            </InputAdornment>
          ),
        }}
        sx={focusStyles}
      />
      <TextField
        label="Facebook"
        name="facebook"
        value={formData.contacts.facebook}
        onChange={(e) => onChange('contacts.facebook', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors['contacts.facebook']}
        helperText={errors['contacts.facebook']}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FacebookIcon sx={{ color: theme.palette.accent.main }} />
            </InputAdornment>
          ),
        }}
        sx={focusStyles}
      />
      <TextField
        label="Instagram"
        name="instagram"
        value={formData.contacts.instagram}
        onChange={(e) => onChange('contacts.instagram', e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors['contacts.instagram']}
        helperText={errors['contacts.instagram']}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <InstagramIcon sx={{ color: theme.palette.accent.main }} />
            </InputAdornment>
          ),
        }}
        sx={focusStyles}
      />
    </Box>
  );
};
